__turbopack_context__.v({
  "avatar": "XFxVGa_avatar",
  "info": "XFxVGa_info",
  "nameRow": "XFxVGa_nameRow",
  "row": "XFxVGa_row",
  "username": "XFxVGa_username",
  "verifiedBadge": "XFxVGa_verifiedBadge",
});
